import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import OAuthCallback from 'components/OAuth/OAuthCallback/OAuthCallback'

import { refreshToken, isOutsideIframe, isAuth, checkIfIsLoopedLogin } from 'utils/general/auth'
import ProtectedRoute from 'views/ProtectedRoute/ProtectedRoute'
import LoginRoute from 'views/LoginRoute'
import Accounts from 'views/Accounts'
import AddAccount from 'views/Accounts/AddAccount'
import EditAccount from 'views/Accounts/EditAccount'
import RolesPermissions from 'views/RolesPermissions'
import AddRole from 'views/RolesPermissions/AddRole'
import EditRole from 'views/RolesPermissions/EditRole'
import PosAccounts from 'views/PosAccounts'

export const AppRoutes = () => {
  useEffect(() => {
    let timeoutId: ReturnType<typeof setInterval>

    if (isOutsideIframe()) {
      if (isAuth()) {
        localStorage.removeItem('redirectToLoginAttemptedCheck')
        refreshToken()
        timeoutId = setInterval(() => refreshToken(), 60000)
      } else {
        checkIfIsLoopedLogin()
      }
    }

    return () => {
      clearInterval(timeoutId)
    }
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<LoginRoute />} path="/login" />
        <Route element={<OAuthCallback />} path="/oauth/callback" />
        <Route element={<ProtectedRoute isAuth={isAuth()} />}>
          {/* Accounts */}
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/accounts/add" element={<AddAccount />} />
          <Route path="/accounts/edit/:id" element={<EditAccount />} />

          {/* Roles & Permissions */}
          <Route path="/roles-permissions" element={<RolesPermissions />} />
          <Route path="/roles-permissions/add" element={<AddRole />} />
          <Route path="/roles-permissions/edit/:id" element={<EditRole />} />

          {/* POS Accounts */}
          <Route path="/pos-accounts" element={<PosAccounts />} />
        </Route>
        <Route element={<Navigate to="/pos-accounts" />} path="*" />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRoutes
